import { Controller } from "stimulus";
import { FocusTrap } from 'shared/assets/javascript/accessibility/focusTrap.js';

export default class extends Controller {
  static targets = [
    'closeButton',
    'contactList',
    'contactSelect',
  ];

  get footerToggle() {
    return document.querySelector('.footer-bar__link--contacts');
  }

  initialize() {
    this.state = {
      active: false,
    };
  }

  connect() {
    this.footerToggle.addEventListener('click', this.modalOpen.bind(this))
    this.closeButtonTarget.addEventListener('click', this.modalClose.bind(this))
    this.contactSelectTarget.addEventListener('change', this.toggleContactList.bind(this))
    this.element.addEventListener('keyup', this.handleKeyUp.bind(this));

    if (this.contactListTargets.length > 0) {
      this.contactListTargets[0].classList.add('active');
    }

    this.modal = this.element
    this.modalToggle = this.closeButtonTarget
    this.focusTrapInstance = new FocusTrap([this.modalToggle, this.modal])

    this.setViewableLists(this.contactListTargets);
  }

  disconnect() {
    this.footerToggle.removeEventListener('click', this.modalOpen.bind(this))
    this.closeButtonTarget.removeEventListener('click', this.modalClose.bind(this))
    this.contactSelectTarget.removeEventListener('change', this.toggleContactList.bind(this))
  }

  modalOpen(){
    this.state.active = true
    this.element.classList.add('active');
    document.body.classList.add('-is-open-modal');
    this.focusTrapInstance.set();
  }

  modalClose(){
    this.state.active = false;
    this.element.classList.remove('active');
    document.body.classList.remove('-is-open-modal');
    this.focusTrapInstance.unset();
    this.footerToggle.focus();
  }

  toggleContactList() {
    const id = this.contactSelectTarget.value
    this.contactListTargets.forEach(el => el.classList.remove('active'))
    this.contactListTargets.filter(el => el.classList.contains(id)).forEach(el => el.classList.add('active'))
    this.setViewableLists(this.contactListTargets);
    this.focusTrapInstance.set();
  }

  setViewableLists(lists) {
    lists.forEach(list => this.setViewableList(list, list.classList.contains('active')));
  }

  setViewableList(list, isViewable) {
    list.setAttribute('aria-hidden', !isViewable);

    const listFocusableElements = list.querySelectorAll('button, a');
    listFocusableElements.forEach(elem => isViewable
      ? elem.removeAttribute('tabindex')
      : elem.setAttribute('tabindex', -1)
    );
  }

  handleKeyUp(event) {
    if ((event.keyCode == 27) && this.state.active) {
      this.modalClose();
    }
  }
}

